import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

const STATUS_LABEL_KEYS = {
  pending: 'chatsocket.scheduling_progress.status.pending',
  uploading: 'chatsocket.scheduling_progress.status.uploading',
  updating_publication: 'chatsocket.scheduling_progress.status.updating',
  creating_publication: 'chatsocket.scheduling_progress.status.creating',
  creating_tiktok_metadata: 'chatsocket.scheduling_progress.status.configuring_tiktok',
  scheduled: 'chatsocket.scheduling_progress.status.scheduled',
  failed: 'chatsocket.scheduling_progress.status.failed',
};

const isCompletedStatus = (status) => status === 'scheduled' || status === 'failed';

export const SchedulingProgress = ({
  items = [],
  summary = null,
  isRunning = false,
  errorMessage = null,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.progressCard}>
      <span className={styles.socialMediaTitle}>{t('chatsocket.scheduling_progress.title')}</span>

      {items.map((item) => {
        const status = item?.status || 'pending';
        const isDone = isCompletedStatus(status);
        const title = item?.pieceName || t('chatsocket.scheduling_progress.post_fallback', { num: item?.pieceNumber || '-' });

        return (
          <div key={item?.pieceNumber || title} className={`${styles.progressItem} ${isDone ? styles.done : ''}`}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
              {isDone ? (
                status === 'scheduled' ? (
                  <path d="M20 6L9 17L4 12" stroke="#00FF09" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                ) : (
                  <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                )
              ) : (
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              )}
            </svg>
            <span>{title}: {t(STATUS_LABEL_KEYS[status] || status)}</span>
            {status === 'failed' && item?.errorMessage ? (
              <span className={styles.errorDetail}>{item.errorMessage}</span>
            ) : null}
          </div>
        );
      })}

      {!items.length && (
        <div className={styles.progressItem}>
          <span>{t('chatsocket.scheduling_progress.no_items')}</span>
        </div>
      )}

      {summary && (
        <div className={styles.progressItem}>
          <span>
            {t('chatsocket.scheduling_progress.scheduled_failed_summary', { scheduled: summary.scheduled, failed: summary.failed })}
          </span>
        </div>
      )}

      {!summary && (
        <div className={styles.progressItem}>
          <span>{isRunning ? t('chatsocket.scheduling_progress.running') : t('chatsocket.scheduling_progress.waiting')}</span>
        </div>
      )}

      {errorMessage && (
        <div className={styles.progressItem}>
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

